"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.permissions = void 0;
var permissions = {
  INTERNAL_ADMIN: 'internalAdmin',
  ACCOUNT_MANAGER_ADMIN: 'accountManagerAdmin',
  STANDARD_USER: 'standardUser',
  NO_ACCESS: 'noAccess'
};
exports.permissions = permissions;